import axios from 'axios';
import { bundle, buildAgentPath } from '../../helpers';
import { handleErrors, headerBuilder, paramBuilder, validateOptions } from '../http';
export var fetchTaskComponent = function fetchTaskComponent() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  validateOptions('fetchTaskComponent', [], options);
  return axios.get("".concat(bundle.apiLocation(), "/platformComponents/task"), {
    params: paramBuilder(options),
    headers: headerBuilder(options)
  }).then(function (response) {
    return {
      task: response.data.task
    };
  })["catch"](handleErrors);
};
export var updateTaskComponent = function updateTaskComponent() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  validateOptions('updateTaskComponent', ['task'], options);
  return axios.put("".concat(bundle.apiLocation(), "/platformComponents/task"), options.task, {
    params: paramBuilder(options),
    headers: headerBuilder(options)
  }).then(function (response) {
    return {
      task: response.data.task
    };
  })["catch"](handleErrors);
};
export var fetchAgentComponents = function fetchAgentComponents() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return axios.get("".concat(bundle.apiLocation(), "/platformComponents/agents"), {
    params: paramBuilder(options),
    headers: headerBuilder(options)
  }).then(function (response) {
    return {
      agents: response.data.agents
    };
  })["catch"](handleErrors);
};
export var fetchAgentComponent = function fetchAgentComponent() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  validateOptions('fetchAgentComponent', ['slug'], options);
  return axios.get("".concat(bundle.apiLocation(), "/platformComponents/agents/").concat(options.slug), {
    params: paramBuilder(options),
    headers: headerBuilder(options)
  }).then(function (response) {
    return {
      agent: response.data.agent
    };
  })["catch"](handleErrors);
};
export var createAgentComponent = function createAgentComponent() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  validateOptions('createAgentComponent', ['agent'], options);
  return axios.post("".concat(bundle.apiLocation(), "/platformComponents/agents"), options.agent, {
    params: paramBuilder(options),
    headers: headerBuilder(options)
  }).then(function (response) {
    return {
      agent: response.data.agent
    };
  })["catch"](handleErrors);
};
export var updateAgentComponent = function updateAgentComponent() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  validateOptions('updateAgentComponent', ['slug', 'agent'], options);
  return axios.put("".concat(bundle.apiLocation(), "/platformComponents/agents/").concat(options.slug), options.agent, {
    params: paramBuilder(options),
    headers: headerBuilder(options)
  }).then(function (response) {
    return {
      agent: response.data.agent
    };
  })["catch"](handleErrors);
};
export var deleteAgentComponent = function deleteAgentComponent() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  validateOptions('deleteAgentComponent', ['slug'], options);
  return axios["delete"]("".concat(bundle.apiLocation(), "/platformComponents/agents/").concat(options.slug), {
    params: paramBuilder(options),
    headers: headerBuilder(options)
  }).then(function (response) {
    return {
      agent: response.data.agent
    };
  })["catch"](handleErrors);
};
export var validateAgent = function validateAgent() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  validateOptions('validateAgent', [], options);
  return axios.get("".concat(buildAgentPath(options), "/app/api/v1/bridges"), {
    params: paramBuilder(options),
    headers: headerBuilder(options)
  }).then(function (response) {
    return {
      successMessage: "".concat(options.agentSlug, " has been successfully validated.")
    };
  })["catch"](handleErrors);
};
export var fetchAgentComponentVersion = function fetchAgentComponentVersion() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  validateOptions('validateAgent', [], options);
  return axios.get("".concat(buildAgentPath(options), "/app/api/v1/version"), {
    params: paramBuilder(options),
    headers: headerBuilder(options)
  }).then(function (response) {
    return {
      version: response.data.version
    };
  })["catch"](handleErrors);
};